module.exports = __webpack_public_path__ + "static/media/img-adaw-small.5d93171a.svg";